/**
 * E2E-Hook `window.__lfVoice` (nur lesend, Form siehe e2e/tests/helpers/voice.ts).
 *
 * Bewusst NICHT in controller.ts: Der LiveKit-Direkttest bündelt den Controller mit esbuild und prüft ihn mit dem
 * CommonJS-tsconfig von e2e – dort ist `import.meta` weder erlaubt noch befüllt. Gesetzt wird der Hook nur im
 * Vite-Dev-Server oder in einem ausdrücklich für E2E gebauten Bündel (`VITE_E2E=1 pnpm --filter web build`).
 */
import { getVoiceController } from './controller';
import { voiceDebugHookEnabled } from './logic';
import type { VoiceDebugState } from './snapshot';

function viteEnv(): { DEV?: boolean; VITE_E2E?: string } | undefined {
  try {
    // Defensiv: außerhalb von Vite ist import.meta.env undefined.
    return (import.meta as { env?: { DEV?: boolean; VITE_E2E?: string } }).env;
  } catch {
    return undefined;
  }
}

export function installVoiceDebugHook(env: { DEV?: boolean; VITE_E2E?: string } | null | undefined = viteEnv()): boolean {
  if (typeof window === 'undefined' || !voiceDebugHookEnabled(env)) return false;
  (window as unknown as { __lfVoice?: () => VoiceDebugState }).__lfVoice = () => getVoiceController().debug();
  return true;
}
